import React from 'react';
import i18n from '@leverege/i18n';
import ValueEditor from "./widgets/ValueEditor.js";
const {
  t,
  tIcon
} = i18n.ns('ui-attributes.detail.customText.textEditor.editors.Link');
export default {
  matches: {
    use: 'MenuBar',
    client: 'CustomTextModelEditor'
  },
  id: 'Rich.Text.Editor.Link',
  layout: {
    sort: 'F'
  },
  handles: () => true,
  customComponent: props => {
    const {
      context: {
        editor
      }
    } = props;
    // renderer needs initial value
    return /*#__PURE__*/React.createElement(ValueEditor, {
      ...props,
      title: t('title'),
      disabled: !editor.can().chain().focus().extendMarkRange('link').setLink({}).run() || editor.isActive('code'),
      icon: tIcon('icon', 'fa fa-link'),
      active: editor.isActive('link'),
      initialValue: editor.getAttributes('link').href,
      apply: t('apply'),
      hint: t('hint'),
      onChange: (value, editor) => {
        if (value && value?.length) {
          editor.chain().focus().extendMarkRange('link').setLink({
            href: value
          }).run();
        } else {
          editor.chain().focus().unsetLink().run();
        }
      }
    });
  }
};